"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const i = require("@nextcloud/initial-state");
function t() {
  try {
    return i.loadState("core", "capabilities");
  } catch {
    return console.debug("Could not find capabilities initial state fall back to _oc_capabilities"), "_oc_capabilities" in window ? window._oc_capabilities : {};
  }
}
exports.getCapabilities = t;
